import { useState, useEffect } from "react";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("radiece_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("radiece_cookie_consent", "accepted");
    setVisible(false);
  };

  const acceptEssentialOnly = () => {
    localStorage.setItem("radiece_cookie_consent", "essential_only");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="no-print fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-xl z-40">
      <div
        role="dialog"
        aria-labelledby="cookie-heading"
        aria-describedby="cookie-desc"
        className="bg-[#101c2a] border border-brand-light/40 rounded-xl shadow-2xl p-5 backdrop-blur-md"
      >
        <div className="sm:flex sm:items-start sm:gap-5">
          <div className="flex-1 mb-4 sm:mb-0">
            <h2 id="cookie-heading" className="text-white font-semibold text-base mb-1">
              Cookie & Privacy Preferences
            </h2>
            <p id="cookie-desc" className="text-slate-300 text-xs leading-relaxed">
              We use essential storage to ensure core website functionality and save your navigation preferences. We do not use third-party advertising or cross-site tracking cookies.
            </p>
          </div>
          <div className="flex items-center gap-2.5 shrink-0">
            <button
              onClick={acceptEssentialOnly}
              aria-label="Use essential cookies and storage only"
              className="px-3.5 py-2 text-xs font-semibold text-slate-300 hover:text-white border border-slate-600 hover:border-slate-500 rounded-lg transition-all min-h-[40px] cursor-pointer whitespace-nowrap"
            >
              Essential Only
            </button>
            <button
              onClick={acceptAll}
              aria-label="Accept all functional cookies and storage"
              className="px-3.5 py-2 text-xs font-bold text-slate-950 bg-primary hover:bg-sky-400 rounded-lg transition-all shadow-sm min-h-[40px] cursor-pointer whitespace-nowrap"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
